import React, { useEffect, useState } from 'react';
import * as swatTrundoManagementAction from "../../../redux/store-sarang/swat-trundo/swat-trundo-management.store";
import { NotificationMessageType, getFestivalCog, formatNumber } from "../../../utils/configuration";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import viVN from "../../../language/vi-VN.json";
import LoadingViewAria from '../../../components/layout-sarang/loading-view-aria'
import { optionsExamination } from '../../../common/constant';
import Popover from '@mui/material/Popover';

export default function SwatTrundoWMTeamRankCupWidget(props) {
    const { userInfo, week, limit, currentFestival } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const [loading, setLoading] = useState(false);
    const [listWMTeamRank, setListWMTeamRank] = useState([]);

    useEffect(() => {
        GetAllListWMTeamRank()
    }, [week, currentFestival]);

    const GetAllListWMTeamRank = async () => {
        setLoading(true);
        try {
            if (!currentFestival) return;
            const res = await swatTrundoManagementAction.GetListWMTeamRank(currentFestival?.id, limit, week?.week);

            if (res && res.content) {
                setListWMTeamRank(res.content);
            }

        } catch (err) {
            if (err && err.errorType) {
                ShowNotification(
                    viVN.Errors[err.errorType],
                    NotificationMessageType.Error
                );
            }
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            {
                //<Popover
                //    id='buoc1'
                //    open={open}
                //    anchorEl={anchorEl}
                //    onClose={handleClose}
                //    anchorOrigin={{
                //        vertical: 'bottom',
                //        horizontal: 'left',
                //    }}
                //>
                //    {/*<Typography sx={{ p: 2 }}>test</Typography>*/}
                //    {
                //        departmentData?.rP_Examination_Report_Dtos && departmentData?.rP_Examination_Report_Dtos.length > 0 &&
                //        <table className="table dataTable">
                //            <thead>
                //                <tr >
                //                    <td style={{ minWidth: "100px" }}><b>Nội dung</b></td>
                //                    <td style={{ minWidth: "50px" }}><b>#</b></td>
                //                    <td style={{ minWidth: "50px" }}><b>Điểm</b></td>
                //                </tr>
                //            </thead>
                //            <tbody>
                //                {
                //                    departmentData?.rP_Examination_Report_Dtos.map((item, index) =>
                //                        <tr>
                //                            <td>{optionsExamination.find(x => x.value == item.status)?.label}</td>
                //                            <td>{item.quantity}</td>
                //                            <td>{item.quantity * item.point}</td>
                //                        </tr>)
                //                }
                //            </tbody>
                //        </table>
                //    }
                //</Popover>
            }
            <div className="card">
                <div className="card-header d-flex">
                    <h4 className="card-header-title" style={{ fontWeight: 700, color: '#68a1c3' }}>Thi đua 12 WM</h4>
                    <div className="card-header-title ml-auto" style={{ fontWeight: 500, color: 'red' }}>
                        {
                            week ? <> (Tuần {week.week})</> : <> (toàn lễ hội)</>
                        }    
                    </div>
                </div>
                
                <div className="card-body">
                    <div className="row text-center">
                        <div className="col-4">
                            {
                                listWMTeamRank.length > 1 &&
                                <div style={{ cursor: 'pointer' }} onClick={(event) => {
                                    //dptmClick(event, listHerdsmanRank[1].departmentId);
                                }}>
                                    <img src="assets/images/rank/Second.png" style={{width: "40px", paddingTop:"10px"}} />
                                        <div style={{ marginTop: "10px", fontWeight: 700 } }>{
                                            listWMTeamRank[1].wmTeamName
                                        }</div>
                                    <div style={{ fontWeight: 900, color:"#0867c3" }}>{
                                            formatNumber(listWMTeamRank[1].totalPoint)
                                        }<br /> &nbsp;</div>
                                </div>
                            }
                        </div>
                        <div className="col-4">
                            {
                                
                                listWMTeamRank.length > 0 &&
                                <div style={{ cursor: 'pointer' }} onClick={(event) => {
                                    //dptmClick(event, listHerdsmanRank[0].departmentId);
                                }}>
                                    <img src="assets/images/rank/First.png" style={{width: "50px"}}  />
                                    <div style={{marginTop: "10px", fontWeight:700} }>{
                                            listWMTeamRank[0].wmTeamName
                                        }</div>
                                        
                                        <div style={{ fontWeight: 900, color: "#0867c3" }}>{
                                            formatNumber(listWMTeamRank[0].totalPoint)
                                        }<br />&nbsp;</div>
                                </div>
                            }
                        </div>
                        <div className="col-4">
                            {
                                listWMTeamRank.length > 2 &&
                                <div style={{ cursor: 'pointer' }} onClick={(event) => {
                                    //dptmClick(event, listHerdsmanRank[3].departmentId);
                                }}>
                                    <img src="assets/images/rank/Third.png" style={{width: "35px", paddingTop:"15px"}}  />
                                        <div style={{ marginTop: "10px", fontWeight: 700 } }>{
                                            listWMTeamRank[2].wmTeamName
                                        }</div>
                                        <div style={{ fontWeight: 900, color: "#0867c3" }}>{
                                            formatNumber(listWMTeamRank[2].totalPoint )
                                    }</div>
                                </div>
                            }
                        </div>
                        
                    </div>
                    <div className="row text-center">
                        <table className="table dataTable table-hover " id="datatable">
                            <thead>
                                <tr>
                                    <td style={{ minWidth: "50px" }}><b>Xếp Hạng</b></td>
                                    <td style={{ minWidth: "100px" }}><b>WM</b></td>
                                    <td style={{ minWidth: "50px" }}><b>Điểm</b></td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    listWMTeamRank.map((item, index) => 
                                        index > 2 && 
                                            <tr key={index}>
                                                <td>{item.rank}</td>
                                                <td style={{ cursor: 'pointer' }} onClick={(event) => {
                                                    //dptmClick(event, item.departmentId);
                                                }}>{item.wmTeamName}</td>
                                                <td>{formatNumber(item.totalPoint)}</td>
                                            </tr>
                                    
                                        )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <LoadingViewAria loading={loading} />
            </div>
        </>
    )
}